import { lazy, Suspense } from "react";
import Hero from "@/components/Hero";
import StoryHook from "@/components/StoryHook";
import { SectionDivider } from "@/components/ui/section-divider";

// Lazy load below-the-fold components
const PreviewCapture = lazy(() => import("@/components/PreviewCapture"));
const VideoTeasers = lazy(() => import("@/components/VideoTeasers"));
const ImpactfulQuotes = lazy(() => import("@/components/ImpactfulQuotes"));
const Reviews = lazy(() => import("@/components/Reviews"));
const Characters = lazy(() => import("@/components/Characters"));
const Author = lazy(() => import("@/components/Author"));
const ContactForm = lazy(() => import("@/components/ContactForm"));
const Footer = lazy(() => import("@/components/Footer"));
const ExitIntentPopup = lazy(() => import("@/components/ExitIntentPopup").then(m => ({ default: m.ExitIntentPopup })));
const QuizLink = lazy(() => import("@/components/QuizLink").then(m => ({ default: m.QuizLink })));

const Index = () => {
  return (
    <div className="min-h-screen relative">
      {/* Global seamless background */}
      <div className="fixed inset-0 bg-background z-[-2]" />
      
      {/* Ambient atmospheric layer */}
      <div className="fixed inset-0 z-[-1]">
        {/* Noise texture */}
        <div className="absolute inset-0 bg-noise opacity-30" />
        
        {/* Animated ambient glows */}
        <div className="absolute top-[10%] left-[15%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[150px] animate-pulse" />
        <div className="absolute top-[30%] right-[10%] w-[600px] h-[600px] bg-[hsl(var(--burgundy))]/5 rounded-full blur-[150px] animate-pulse" style={{ animationDelay: "2s" }} />
        <div className="absolute top-[60%] left-[20%] w-[400px] h-[400px] bg-primary/5 rounded-full blur-[150px] animate-pulse" style={{ animationDelay: "4s" }} />
        <div className="absolute bottom-[20%] right-[25%] w-[550px] h-[550px] bg-[hsl(var(--burgundy))]/5 rounded-full blur-[150px] animate-pulse" style={{ animationDelay: "6s" }} />
        
        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[hsl(var(--burgundy))]/3 via-transparent to-[hsl(var(--burgundy))]/3" />
      </div>
      <Hero />
      <SectionDivider style="ornamental" variant="gradient" />
      <StoryHook />
      <SectionDivider style="minimal" variant="primary" />
      <Suspense fallback={<div className="min-h-[50vh]" />}>
        <QuizLink />
        <VideoTeasers />
        <SectionDivider style="floral" variant="burgundy" />
        <ImpactfulQuotes />
        <PreviewCapture />
        <SectionDivider style="ornamental" variant="gradient" />
        <Reviews />
        <Characters />
        <SectionDivider style="floral" variant="primary" />
        <Author />
        <SectionDivider style="minimal" variant="burgundy" />
        <ContactForm />
        <Footer />
        <ExitIntentPopup />
      </Suspense>
    </div>
  );
};

export default Index;
